import React from 'react';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@/src/utils/i18n.utils';

interface JamTaskAuditModalProps {
  message?: string;
  showAuditModal: boolean;
  onClose: () => void;
  onDismiss: () => void;
}

const JamTaskAuditModal: React.FC<JamTaskAuditModalProps> = ({ message, showAuditModal, onClose, onDismiss }) => {
  const { t } = useTranslation();

  return (
    <Modal
      onDismiss={onDismiss}
      visible={showAuditModal}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
              <Button variant="primary" data-testid="taskAuditCloseButton" onClick={onClose}>{t(i18nKeys.general.close)}</Button>
          </SpaceBetween>
        </Box>
      }
      >
      { message }
    </Modal>
  );
};

export default JamTaskAuditModal;
